module.exports = __webpack_public_path__ + "static/img/pingancover.ce83699d.png";